﻿/** @typedef {(element: Element, args: any[]) => any} FactoryFn */

/** @type { Map<FactoryFn, WeakMap<Element, ReturnType<FactoryFn>>> } */
const components = new Map();

/**
 * @param {FactoryFn} factory
 * @param {Element} element
 * @param {any[]} args
 */
function initOne(factory, element, args) {
	let componentMap = components.get(factory);
	if (!componentMap) {
		components.set(factory, componentMap = new WeakMap());
	}
	let component;
	// stored is the result of factory function which might be undefined. Use .has(), do not check !.get()
	if (componentMap.has(element)) {
		component = componentMap.get(element);
	} else {
		component = factory(element, ...args);
		componentMap.set(element, component);
	}
	return component;
}

function destroy(factory, ...element) {
	const componentMap = components.get(factory);
	element.forEach(e => componentMap.delete(e));
}

// init(selector, factory, args[])
// init(selector, context, factory, args[])
// init(element, factory, args[])
// init(element, undefined, factory, args[])


/**
 * @param {FactoryFn} factory;
 * @param {string|NodeList|Node} a0
 * @param {Element} element
 */
function init(factory, a0, args) {
	if (typeof a0 === "string") {
		let context = document;
		if (args[0] == null || "querySelectorAll" in args[0]) {
			context = args.splice(0, 1)[0] ?? document;
		}
		return Array.from(context.querySelectorAll(a0)).map(element => initOne(factory, element, args));
	} else if (a0 instanceof NodeList) {
		return Array.from(a0).map(element => initOne(factory, element, args));
	} else if (a0 instanceof Node) {
		return initOne(factory, a0, args);
	} else {
		console.error("Invalid argument", a0);
	}
}

/**
 * @param {FactoryFn} factory
 * @returns {(a0: string|NodeList|Node, ...args: any[]) => ReturnType<FactoryFn>}
 */
const registerComponent = (factory) => (a0, ...args) => init(factory, a0, args);

/**
 * @param {FactoryFn} factory
 * @returns {(element: any[]) => void}
 */
const removeComponent = (factory) => (...element) => destroy(factory, element);

export { registerComponent, removeComponent };